import React from 'react'
import CustTable from '../../Common/CustTable'
import { t } from 'i18next'
import { Button } from 'antd'
import { FormOutlined } from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { tagFormat } from '../../Common/Common'
import Pagination from '../../Common/Pagination'
import EventInChargeSelect from './EventInChargeSelect'

const displayTags = (event) => {
  return event.tags.map((tag) => (<div key={`${event.id}-${tag.id}`}>{tagFormat(tag, 'tag')}</div>))
}

export default function EventListXS ({ events, pagination, getEvents, filters, updateEvents, inCharge }) {
  const columns = () => [
    {
      width: 40,
      title: t('Admin.EventList.table.inCharge'),
      dataIndex: 'in_charge',
      key: 'in_charge',
      render: (_, o) => <EventInChargeSelect event={o} updateEventData={updateEvents} inCharge={inCharge} />
    },
    {
      width: 40,
      title: t('Admin.EventList.table.tag'),
      dataIndex: 'tag',
      key: 'tag',
      render: (_, o) => displayTags(o)
    },
    {
      width: 60,
      title: t('Admin.EventList.table.title'),
      dataIndex: 'title',
      key: 'title',
      sorter: (a, b) => a.title.localeCompare(b.title)
    },
    {
      width: 40,
      title: t('Admin.EventList.table.box'),
      dataIndex: 'box',
      key: 'box',
      sorter: (a, b) => a.box - b.box,
      render: (_, event) => (event.box && <Link to={`/admin/boxes/${event.box.id}/calendar`}>{event.box.name}</Link>)
    },
    {
      width: 10,
      key: 'action',
      render: (_, o) => (<>
        <Link key='edit' to={`/admin/events/${o.id}`}><Button shape="circle" icon={<FormOutlined />} /></Link>
      </>)
    }
  ]

  const rowClassName = (record) => {
    return record.new ? 'new-event' : ''
  }

  const onChange = (page) => {
    getEvents(filters, page)
  }

  return (
    <>
      {pagination.current_page && <Pagination currentPage={parseInt(pagination.current_page)} maxPage={parseInt(pagination.max_page)} onChange={onChange} />}
      <CustTable
        style={{ height: 'calc(100vh - 290px)' }}
        height={700}
        width={'400px'}
        initColumns={columns()}
        key={'number'}
        className={'xs-events'}
        rowClassName={rowClassName}
        dataSource={events}
        tableLayout={'auto'}
      />
    </>
  )
}
